import { Plus } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import styles from './AutomationsTab.module.css';

interface TemplatesTableControlsProps {
  onCreateTemplate: () => void;
}

export function TemplatesTableControls({ onCreateTemplate }: TemplatesTableControlsProps) {
  return (
    <Button onClick={onCreateTemplate} className={styles.newTemplateButton}>
      <Plus className={styles.icon} />
      New Automation
    </Button>
  );
}
